import { Box } from "@aircall/tractor";
import styled from "@xstyled/styled-components";

export const Timeline = styled(Box)`
  width: 100%;
  height: 6px;
  background-color: graphic-default;
  border-radius: 8px;
  position: relative;
`;
